import React from 'react';
import styled from 'styled-components';
import Circle from '@atoms/Circle';
import CircleDangerIcon from '@icons/CircleDangerIcon';
import { PropTypes } from 'prop-types';

const StyledErrorMessage = styled.div`
    background-color: #f1a79e;
    display: flex;
    padding: 8px;

    p {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        margin-bottom: 0;
    }
`;

const AuthenticationErrorNotice = ({ error }) => {
    return (
        <StyledErrorMessage className="mb-3">
            <Circle size="22">
                <CircleDangerIcon color="#000" />
            </Circle>
            <p className="ml-1">{error}</p>
        </StyledErrorMessage>
    );
};

AuthenticationErrorNotice.propTypes = {
    error: PropTypes.string,
};

export default AuthenticationErrorNotice;
